import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AddressSearcherService } from '@df/ui/form/address-searcher.service';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { PcaAddressSearcherService } from './pca-address-searcher.service';
import { NPca } from './pca.interfaces';

export function provideDfModulePca(config?: DeepPartial<NPca.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: AddressSearcherService,
            useClass: PcaAddressSearcherService
        },
        {
            provide: NPca.OPTIONS,
            useFactory: () => {
                return defaultsDeep(config, NPca.DEFAULT_OPTIONS);
            }
        }
    ]);
}
